import React from 'react';
import '../styles/shared/Footer.css';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import logo from '../assests/SA BLU.png'
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import { CERTIFICATE_URL } from '../components/Certifications';

const QUICK_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/about', label: 'About Us' },
  { to: '/workplace_safety', label: 'Workplace Safety' },
  { to: '/contact', label: 'Contact Us' },
]

const Footer = () => {
  return (
    <footer className='footer'>
      <Container>
        <Row className="footer__row">
          <Col lg={4} md={12} className="footerLogo">
            <Link to='/'>
              <Image src={logo} className="img-fluid" alt="42 Card Solutions" />
            </Link>

            <a
              className="footer__cert"
              href={CERTIFICATE_URL}
              target="_blank"
              rel="noopener noreferrer"
              title="View our certificate of registration"
            >
              <span className="footer__cert-mark" aria-hidden="true">
                <VerifiedUserOutlinedIcon />
              </span>
              <span className="footer__cert-body">
                <strong>ISO 27001</strong>
                <span className="footer__cert-meta">Certified</span>
              </span>
            </a>
          </Col>
          <Col lg={3} md={5} className="quick-link">
            <h2>Quick Links</h2>
            <span className="footer__rule" />
            <ul>
              {QUICK_LINKS.map(({ to, label }) => (
                <li key={to}><Link to={to}>{label}</Link></li>
              ))}
            </ul>
          </Col>
          <Col lg={5} md={7}>
            <h2>Connect With Us</h2>
            <span className="footer__rule" />

            <a href='mailto:info@42cards.in' className="footer__contact emailIcon">
              <EmailIcon fontSize="small" />
              <span>info@42cards.in</span>
            </a>

            <div className="footer__contact footer__contact--static">
              <PlaceOutlinedIcon fontSize="small" />
              <span className="footer__address">
                <span className='subaddress'>42 Card Solutions Private Limited,</span>
                <span className='subaddress'>559, 2nd floor, AECS Layout Main Rd,</span>
                <span className='subaddress'>Sri Nivasa Reddy Layout, AECS Layout, Marathahalli,</span>
                <span className='subaddress'>Bengaluru, Karnataka - 560037.</span>
                <span className='subaddress'> CIN Number : U72900KA2020PTC141127</span>
              </span>
            </div>

            <h2 className="footer__follow">Follow Us</h2>
            <span className="footer__rule" />
            <div className="socialIcon">
              <a
                href="https://www.linkedin.com/company/42-card-solutions-pvt-ltd"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="linkedinIcon"
              >
                <LinkedInIcon />
              </a>
              <a
                href="https://twitter.com/42cardsolutions"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
                className="twitterIcon"
              >
                <TwitterIcon />
              </a>
              <a
                href="https://www.youtube.com/channel/UCDE2mxycdQv705jVb0JwGjw"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="youTubeIcon"
              >
                <YouTubeIcon />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
